module.exports = global["$"] = require("-!/Applications/MAMP/htdocs/turbo-html/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?$!./~/jquery/dist/jquery.js
 ** module id = 16
 ** module chunks = 0
 **/